import React, { useEffect, useRef, useState } from 'react';
import { mlgraph } from '../../services/mlgraph-service';
import Sigma from 'sigma';
import Graph from 'graphology';

interface Props {
  clusterName: string;
  clusterId: number;
}

export default function GraphCanvas({ clusterName, clusterId }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const sigmaRef = useRef<Sigma | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchGraph() {
      try {
        const data = await mlgraph.getClustersClusterNameGraphClusterId(clusterName, clusterId);
        const graph = new Graph();

        (data.nodes ?? []).forEach((node: any) => {
          graph.addNode(String(node.node_id), {
            label: String(node.node_id),
            x: Math.random() * 100,
            y: Math.random() * 100,
            size: 5,
            ...node.data,
          });
        });

        (data.edges ?? []).forEach((edge: any, index: number) => {
          graph.addEdgeWithKey(`e${index}`, String(edge.source), String(edge.target), {
            label: edge.matching_fields?.join(', ') || ''
          });
        });

        if (sigmaRef.current) sigmaRef.current.kill();
        sigmaRef.current = new Sigma(graph, containerRef.current!);
      } catch (err) {
        setError('Failed to load graph');
      }
    }
    fetchGraph();
  }, [clusterName, clusterId]);

  return (
    <div>
      <div ref={containerRef} style={{ width: '100%', height: '500px', border: '1px solid #ccc' }} />
      {error && <div style={{ color: 'red' }}>{error}</div>}
    </div>
  );
}